import './index.css';
import Vuex from 'vuex';
import './services/request';
import moment from 'moment';
import App from './App.vue';
import router from './router';
import { createApp } from 'vue';
import Notifications from '@kyvg/vue3-notification';
import i18n from './i18n';
import KeycloakService from './services/KeycloakService';
import setupInterceptors from './services/setupInterceptors';

setupInterceptors();

if (!localStorage.key('showSidebar')) {
    localStorage.setItem('showSidebar', true);
}

const renderApp = () => {
    createApp(App)
        .use(Vuex)
        .use(router)
        .use(store)
        .use(Notifications)
        .use(i18n)
        .use(KeycloakPlugin)
        .mount('#app');
};

let keycloak = KeycloakService();

keycloak.initKeycloak(renderApp);

const KeycloakPlugin = {
    install: (app) => {
        app.config.globalProperties.$keycloak = keycloak;
    }
};

if (!localStorage.getItem('monitorView')) {
    localStorage.setItem('monitorView', 'desktop');
}

const store = new Vuex.Store({
    state: {
        userRoles: keycloak.userRoles,
        permittedPaths: [],
        chartDate: {
            0: moment().format('Y-MM-DD'),
            1: moment().format('Y-MM-DD')
        },
        showSidebar: JSON.parse(localStorage.getItem('showSidebar')),
        monitorView: localStorage.getItem('monitorView'),
        updateTime: 3600000,
        settingsShow: false,
    },
    mutations: {
        setChartDate(state) {
            state.chartDate = localStorage.getItem('chartPeriod').split(',');
        },
        toggleSidebar(state) {
            state.showSidebar = !state.showSidebar;
            localStorage.setItem('showSidebar', state.showSidebar);
        },
        toggleMonitorView(state, val) {
            localStorage.setItem('monitorView', val);
            state.monitorView = val;
        },
        setUpdateTime(state, val) {
            state.updateTime = val;
        },
        toggleSettingsShow(state, val) {
            state.settingsShow = val;
        },
        setPermittedPaths(state, val) {
            state.permittedPaths = val;
        }
    },
    getters: {
        getUserRoles: (state) => {
            return state.userRoles;
        },
        getMonitorView: (state) => {
            return state.monitorView;
        },
        getUpdateTime: (state) => {
            return state.updateTime;
        },
        getSettingsShow: (state) => {
            return state.settingsShow;
        },
        getPermittedPaths: (state) => {
            return state.permittedPaths;
        }
    }
});
